import { useState, useEffect, useRef } from 'react';
import '../App.css';
import '../Tabs.css';
import 'rsuite/DatePicker/styles/index.css';
import { request } from '../utils/ApiUtils';
import Input from './Input';
import AutoCompleteSimples from './AutoCompleteSimples';
import SearchIcon from '@mui/icons-material/Search';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import BalancoFinanceiroReceitasTab from './BalancoFinanceiroReceitasTab';
import BalancoFinanceiroDespesasTab from './BalancoFinanceiroDespesasTab';
import Loading from './Loading';
import CollapsibleFilters from './CollapsibleFilters';
import { FaBalanceScale } from 'react-icons/fa';
import { formatToBRL } from '../utils/MonetaryUtils';


function BalancoFinanceiroForm() {
    const [error, setError] = useState({})
    const [balancoFinanceiro, setBalancoFinanceiro] = useState({})
    const [loading, setLoading] = useState({loading: false});

    const [ano, setAno] = useState(null)
    const [mes, setMes] = useState(null)

    const [refreshKey, setRefreshKey] = useState(0);
    const [activeTab, setActiveTab] = useState("abaReceitas");

    useEffect(() => {
        const dataAtual = new Date();

        const anoAtual = dataAtual.getFullYear(); 
        const mesAtual = dataAtual.getMonth() + 1;

        setAno(anoAtual)
        setMes(mesAtual)
    }, []);

    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
    };

    const findBalancoFinanceiro = async () => {
        if (mes && ano) {
            
            setLoading({loading: true});
            setRefreshKey((prev) => prev + 1);
        }
        request(`balanco-financeiro/totais/${mes}/${ano}`, {
            type: 'GET',
            callback: (data) => (
                setBalancoFinanceiro(data),
                setLoading({loading: false})

            ),
            callbackError: (message) => {
                setLoading({loading: false});
            }

        })
    };

    const abaDespesas = () => (
        <div
            className={`tab ${activeTab === "abaDespesas" ? "active" : ""}`}
            onClick={() => handleTabClick("abaDespesas")}
        >
            Despesas
        </div>
    )

    const tabs = () => (
        <div>
            <div className="tabs">
                <div
                    className={`tab ${activeTab === "abaReceitas" ? "active" : ""}`}
                    onClick={() => handleTabClick("abaReceitas")}
                >
                    Receitas
                </div>

                {abaDespesas()}
            </div>

            {activeTab === "abaReceitas" && <div className={`tab-content active}`}>
                <BalancoFinanceiroReceitasTab refreshKey={refreshKey} ano={ano} mes={mes} />
            </div>}

            {activeTab === "abaDespesas" && <div className={`tab-content active}`}>
                <BalancoFinanceiroDespesasTab refreshKey={refreshKey} ano={ano} mes={mes} />
            </div>}

        </div>
    );

    const saldoDescription = Number(balancoFinanceiro?.saldo || 0) >= 0
        ? 'Resultado financeiro positivo'
        : 'Resultado financeiro negativo';

    return (
        <div className="form-container">


            <div id="notification-container" className='notification-container' style={{
                position: "fixed",
                display: "flex,",
                flexDirection: "column-reverse",
                justifyContent: "flex-end",
                flexWrap: "wrap-reverse",
                alignItems: "flex-end",
                bottom: "0,",
                right: "30px",
                maxHeight: "100vh"
            }}></div>

            <div className="header-container">
                <div className="page-title-content">
                    <FaBalanceScale aria-hidden="true" />
                    <h1 style={{ color: 'black' }}>Balanço Financeiro</h1>
                </div>
            </div>

            <div className={'row-with-auto-complete'}>

                <Input id="ano"
                    value={ano}
                    parameters={{
                        error: error.ano, width: '7%', max: 3000, type: 'number', label: "Ano*", onChange: (value) => {
                            setError({ ...error, ano: undefined })
                            setAno(value)
                        }
                    }} />

                <AutoCompleteSimples
                    label="Mês"
                    // multiple={true}
                    disableClearable={true}
                    value={{ id: mes }}
                    width='7%'
                    options={[{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5 }, { id: 6 }, { id: 7 }, { id: 8 }, { id: 9 }, { id: 10 }, { id: 11 }, { id: 12 }]}
                    getLabel={(item) => `${item ? item.id : ''}`}
                    onChange={(value) => {
                        setError({ ...error, mes: undefined })
                        setMes(value.id)
                    }} />

                <button className="search-button" disabled={!ano || !mes} type="button" onClick={() => findBalancoFinanceiro()}>
                    <SearchIcon fontSize="small" />
                    
                </button>
            </div>

            {refreshKey > 0 && <>
                <div className="receitas-summary balanco-summary" aria-label="Resumo financeiro do período">
                    <section className="receitas-summary-card balanco-summary-card-revenue">
                        <span className="receitas-summary-label"><ArrowUpwardIcon aria-hidden="true" /> Total de Receitas</span>
                        <strong>{formatToBRL(balancoFinanceiro?.totalReceitas)}</strong>
                        <span className="receitas-summary-description">Receitas no período selecionado</span>
                    </section>
                    <section className="receitas-summary-card balanco-summary-card-expense">
                        <span className="receitas-summary-label"><ArrowDownwardIcon aria-hidden="true" /> Total de Despesas</span>
                        <strong>{formatToBRL(balancoFinanceiro?.totalDespesas)}</strong>
                        <span className="receitas-summary-description">Despesas no período selecionado</span>
                    </section>
                    <section className="receitas-summary-card balanco-summary-card-balance">
                        <span className="receitas-summary-label"><FaBalanceScale aria-hidden="true" /> Saldo do Período</span>
                        <strong>{formatToBRL(balancoFinanceiro?.saldo)}</strong>
                        <span className="receitas-summary-description">{saldoDescription}</span>
                    </section>
                </div>

                <div className='header-body-margin-bottom'>
                    <h4 style={{ color: 'black', display: 'inline-block', textShadow: '0 6px 6px rgba(122, 116, 182, 0.5)' }}>Detalhamento Financeiro</h4>
                </div>
            </>}

            {refreshKey > 0 && tabs()}

        </div>
    );
}

export default BalancoFinanceiroForm;
